import { lexonHttp } from '@/plugins/axios/lexonHttp'
import type {
  SearchIAParams,
  AdvanceSearchDislikeParams,
  AdvanceSearchLikeParams
} from '@/modules/documentSearcher/types/SearchIATypes'

export const searchIA = async (
  params: SearchIAParams,
  timeoutMs: number = 300000,
  signal?: AbortSignal
): Promise<any> => {
  const url = `v2/advance-search`

  const formData = new FormData()
  formData.append('search', params.search)

  if (params.expedientName) {
    formData.append('expedient', params.expedientName)
  }

  if (params.contactName) {
    formData.append('client', params.contactName)
  }

  return lexonHttp.post(url, formData, {
    timeout: timeoutMs,
    signal
  })
}

export const likeAdvanceSearch = async (params: AdvanceSearchLikeParams): Promise<any> =>
  lexonHttp.post('v2/advance-search/opinion', {
    quest: params.question,
    ok: true
  })

export const dislikeAdvanceSearch = async (params: AdvanceSearchDislikeParams): Promise<any> =>
  lexonHttp.post('v2/advance-search/opinion', {
    quest: params.question,
    feedback: params.opinion,
    ok: false
  })
